import { useState } from "react";
import { Link } from "react-router-dom";
import { Heart, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { money, mainImage } from "../lib/api";

export default function ProductCard({ product: p, onAdd, onToggleWish, inWishlist }) {
  const [wish, setWish] = useState(!!inWishlist);
  const toggle = (e) => {
    e.preventDefault(); e.stopPropagation();
    const next = !wish;
    setWish(next);
    onToggleWish?.(p.id);
    toast[next ? "success" : "message"](next ? "Saved to wishlist" : "Removed from wishlist", { description: p.name });
  };
  const add = (e) => {
    e.preventDefault(); e.stopPropagation();
    onAdd?.(p);
    toast.success("Added to your collection", { description: p.name });
  };
  const outOfStock = (p.stock ?? 0) <= 0;
  return (
    <article className="product-card" data-testid={`product-card-${p.id}`}>
      <div className="product-image">
        <Link to={`/product/${p.slug || p.id}`} aria-label={p.name} data-testid={`product-image-${p.id}`}>
          <img src={mainImage(p)} alt={p.name} loading="lazy" />
        </Link>
        <button className={wish ? "wish active" : "wish"} onClick={toggle}
                aria-label={wish ? "Remove from wishlist" : "Save to wishlist"}
                data-testid={`wishlist-${p.id}`}>
          <Heart size={17} fill={wish ? "currentColor" : "none"} />
        </button>
        {p.featured && <span className="ribbon">Editor's pick</span>}
        {outOfStock && <span className="ribbon ribbon-muted">Out of stock</span>}
        {!outOfStock && (
          <button className="quick" onClick={add} data-testid={`quick-add-${p.id}`}>
            Add to cart <ArrowRight size={14}/>
          </button>
        )}
      </div>
      <div className="product-copy">
        <div>
          <span className="eyebrow">{p.material || p.category}</span>
          <Link to={`/product/${p.slug || p.id}`} data-testid={`product-name-${p.id}`}>
            <h3>{p.name}</h3>
          </Link>
        </div>
        <strong>{money(p.price)}</strong>
      </div>
    </article>
  );
}
